var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.3294C9.61 16.3294 7.67 14.3894 7.67 11.9994C7.67 9.60943 9.61 7.66943 12 7.66943C14.39 7.66943 16.33 9.60943 16.33 11.9994C16.33 14.3894 14.39 16.3294 12 16.3294ZM12 9.16943C10.44 9.16943 9.17 10.4394 9.17 11.9994C9.17 13.5594 10.44 14.8294 12 14.8294C13.56 14.8294 14.83 13.5594 14.83 11.9994C14.83 10.4394 13.56 9.16943 12 9.16943Z",
    fill: "#B2ABBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.0195C8.24 21.0195 4.69 18.8195 2.25 14.9995C1.19 13.3495 1.19 10.6595 2.25 8.99949C4.7 5.17949 8.25 2.97949 12 2.97949C15.75 2.97949 19.3 5.17949 21.74 8.99949C22.8 10.6495 22.8 13.3395 21.74 14.9995C19.3 18.8195 15.75 21.0195 12 21.0195ZM12 4.47949C8.77 4.47949 5.68 6.41949 3.52 9.80949C2.77 10.9795 2.77 13.0195 3.52 14.1895C5.68 17.5795 8.77 19.5195 12 19.5195C15.23 19.5195 18.32 17.5795 20.48 14.1895C21.23 13.0195 21.23 10.9795 20.48 9.80949C18.32 6.41949 15.23 4.47949 12 4.47949Z",
    fill: "#B2ABBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9c5512c80a4ca210c3b807142fdbd5c8.svg";
export { ForwardRef as ReactComponent };